import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { WEB_USER_URL } from '../../constants/config';

@Component({
  selector: 'searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss']
})
export class SearchboxComponent implements OnInit {
  searchForm: FormGroup;

  constructor(private formBuilder: FormBuilder) { }

  initSearchForm() {
    this.searchForm = this.formBuilder.group({
      keySearch: ['']
    })
  }

  searchLot() {
    let url = `${WEB_USER_URL}search-result/?keyword=${this.searchForm.value.keySearch}`;
    window.open(url, '_blank');
  }

  ngOnInit() {
    this.initSearchForm();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/searchbox/searchbox.component.ts